// import { StrictMode } from 'react';
// import { BrowserRouter } from 'react-router-dom';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import {App} from './app/app';
import store from './store';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  // {/* </StrictMode> */}
);
// Service worker is now handled by vite-plugin-pwa with autoUpdate
// v1774452585
